<template>
    <article class="venueinfo">
        <div class="venueinfo-banner">
            <img src="../assets/imgs/true.jpg" alt="俱乐部说明">
        </div>
        <header class="venueinfo-header bcw">
            <h1>关于私教等级的说明</h1>
            <div class="c9 fs1 mtn">今天</div>
        </header>
        <div class="venueinfo-content c6 fs3">
            (一)适应对象<br/>
            对台球教练指导员的职业感兴趣、从事或准备从事台球教练指导员职业或希望进一步提高专业水平的人员。<br/>
            (二)申报条件<br/>
            1. 初级教练(具备以下条件之一者)<br/>
            (1)经本职业初级正规培训达到规定标准学时数，并取得结业证书。<br/>
            (2)连续从事本职业工作1年以上，并授课400小时以上。<br/>
            (3)取得高等院校体育专业专科以上毕业证书。<br/>
            2. 中级教练(具备以下条件之一者)<br/>
            (1)取得本职业初级职业资格证书后，连续从事本职业工作2年以上，经本职业中级正规培训达到规定标准学时数，并取得结业证书。<br/>
            (2)连续从事本职业工作3年以上，并授课达1500节。<br/>
            (3)取得高等院校体育专业本科及以上毕业证书，并有一年台球教练实际工作经验者。<br/>
            (4)取得一级(含)以上运动员等级证书，经本职业中级正规培训达到规定标准学时数，并取得结业证书。<br/>
            3. 高级教练(具备以下条件之一者)<br/>
            (1)取得本职业中级职业资格证书后，连续从事本职业工作3年以上，经本职业高级正规培训达到规定标准学时数，并取得结业证书。<br/>
            (2)取得本职业中级职业资格证书后，连续从事本职业工作5年以上。<br/>
            4. 指导师级教练(具备以下条件之一者)<br/>
            (1)取得本职业高级职业资格证书后，连续从事本职业工作3年以上，经本职业指导师正规培训达到规定标准学时数，并取得结业证书。<br/>
            (2)取得本职业高级职业资格证书后，连续从事本职业工作5年以上。<br/>
        </div>
    </article>
</template>
<script>
export default {
    name: 'VenueInfo3',
    data() {
      return {
        clubInfo: {},  
      }
    },
    created() {
    
    }
}
</script>
<style lang="less" scoped>
body{
    background-color: white;
}
.venueinfo{
    position: relative;
    &-header{
        position: absolute;
        top: 1.1rem; left: 5%;
        width: 90%;
        padding: .1rem;
        border: .01rem solid #eee;
        border-radius: .02rem;
        &>h1{
            font-size: .2rem;
        }
    }
    &-content{
        margin: .15rem;
        padding-top: .2rem;
        line-height: 1.6;
        & p{
            text-indent: 2em;
            margin-bottom: .1rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/VenueInfo3.vue